import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Redirect} from "react-router";
import {authSelectors} from "../../store/auth";
import Layout from '../../components/Layout'
import CheckinPage from '../../pages/Checkin'
import Loading from "../../components/Base/Loading";
import {searchActions, searchSelectors} from "../../store/search";
import {schoolSelectors} from "../../store/school";


class CheckinContainer extends Component {

	state = {
		students: [],
		loading: true,
		myCheckinList: [],
		otherCheckinList: [],
		liveCheckinList: []
	}

	componentDidMount() {
		this.listener = this.getStudentListener()
	}


	getStudentListener = () => {
		return this.props.firebase.students().orderBy('last_name', 'asc').onSnapshot(snapshot => {
				let result = [];
				snapshot.forEach(doc => (result.push({id: doc.id, ...doc.data()})));
				this.props.updateStudents(result)
				this.setState({students: result, loading: false})
			}
		)
	}


	componentWillUnmount() {
		this.listener()
	}

	render() {
		const { loadingAuth, profile, isFaculty } = this.props;
		if(!loadingAuth){
			if(!isFaculty){
				if(!profile.is_prefect){
					return <Redirect to={'/app/home'}/>
				}
			}
		}
		return (
			<Layout {...this.props} noSideBar>
				{loadingAuth ? <Loading/>
					:
					<CheckinPage {...this.props}/>
				}
			</Layout>
		);
	}
}

function mapStateToProps(state) {
	return {
		loadingAuth: authSelectors.isLoading(state.auth),
		schoolInfo: schoolSelectors.refreshSchool(state.school),
		profileInfo: authSelectors.refreshProfile(state.auth),
		// loading: authSelectors.isLoading(state.auth),
		search: searchSelectors.refreshSearch(state.search),
		filters: searchSelectors.refreshFilters(state.search),
		students: searchSelectors.refreshStudents(state.search),

		isFaculty: authSelectors.isFaculty(state.auth),
		loading: searchSelectors.isLoading(state.search),
		loadingSchool: schoolSelectors.isLoading(state.school)
	};
}

const mapDispatchToProps = dispatch => ({

	updateStudents: (students) => {
		dispatch(searchActions.updateStudents(students))
	},
	updateSearch: (term) => {
		dispatch(searchActions.updateSearch(term));
	},
	updateFilter: (filters) => {
		dispatch(searchActions.updateFilter(filters))
	},
	clearSearch: () => {
		dispatch(searchActions.clearSearch());
	},
	clearFilter: () => {
		dispatch(searchActions.clearFilter());
	},
	updatePlaceholder: (placeholder) => {
		dispatch(searchActions.updatePlaceholder(placeholder))
	}
});

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(CheckinContainer);
